import {get, post, upload} from '@/utils/request'

const SERVICE_URL = '/mdata-service/v1'

/** 银行 */
export function fetchBankList(params) {
    return post(SERVICE_URL + '/mdBank/mdBankList', params)
}

export function getBankList(params) {
    return post(SERVICE_URL + '/mdBank/list', params)
}

export function getBankCount(params) {
    return post(SERVICE_URL + '/mdBank/count', params)
}

export function getBankById(params, pathParam) {
    return get(SERVICE_URL + '/mdBank/getById', params, pathParam)
}
export function createBank(params) {
    return post(SERVICE_URL + '/mdBank/add', params)
}
export function editBank(params) {
    return post(SERVICE_URL + '/mdBank/edit', params)
}
export function deleteBank(params, pathParam) {
    return get(SERVICE_URL + '/mdBank/remove', params, pathParam)
}

// 工厂
export function fetchFactoryList(params) {
    return post(SERVICE_URL + '/mdFactory/mdFactoryList', params)
}
export function getFactoryList(params) {
    return post(SERVICE_URL + '/mdFactory/list', params)
}
export function getFactoryById(params, pathParam) {
    return get(SERVICE_URL + '/mdFactory/getById', params, pathParam)
}
export function createFactory(params) {
    return post(SERVICE_URL + '/mdFactory/add', params)
}
export function editFactory(params) {
    return post(SERVICE_URL + '/mdFactory/edit', params)
}
export function deleteFactory(params, pathParam) {
    return get(SERVICE_URL + '/mdFactory/remove', params, pathParam)
}

// 支付条件
export function fetchPayConditionList(params) {
    return post(SERVICE_URL + '/mdPayCondition/mdPayConditionList', params)
}

export function fetchPayConditionListAll(params) {
    return post(SERVICE_URL + '/mdPayCondition/mdPayConditionListAll', params)
}

export function getPayConditionList(params) {
    return post(SERVICE_URL + '/mdPayCondition/list', params)
}

export function getPayConditionById(params, pathParam) {
    return get(SERVICE_URL + '/mdPayCondition/getById', params, pathParam)
}
export function createPayCondition(params) {
    return post(SERVICE_URL + '/mdPayCondition/add', params)
}
export function editPayCondition(params) {
    return post(SERVICE_URL + '/mdPayCondition/edit', params)
}
export function deletePayCondition(params, pathParam) {
    return get(SERVICE_URL + '/mdPayCondition/remove', params, pathParam)
}

// 省份
export function fetchProvinceList(params) {
    return post(SERVICE_URL + '/mdProvince/mdProvinceList', params)
}

export function getProvinceList(params) {
    return post(SERVICE_URL + '/mdProvince/list', params)
}

export function getProvinceById(params, pathParam) {
    return get(SERVICE_URL + '/mdProvince/getById', params, pathParam)
}
export function createProvince(params) {
    return post(SERVICE_URL + '/mdProvince/add', params)
}
export function editProvince(params) {
    return post(SERVICE_URL + '/mdProvince/edit', params)
}
export function deleteProvince(params, pathParam) {
    return get(SERVICE_URL + '/mdProvince/remove', params, pathParam)
}

// 采购组
export function fetchPurchaseOrgList(params) {
    return post(SERVICE_URL + '/mdPurchaseOrg/mdPurchaseOrgList', params)
}

export function getPurchaseOrgList(params) {
    return post(SERVICE_URL + '/mdPurchaseOrg/list', params)
}

export function getPurchaseOrgById(params, pathParam) {
    return get(SERVICE_URL + '/mdPurchaseOrg/getById', params, pathParam)
}
export function createPurchaseOrg(params) {
    return post(SERVICE_URL + '/mdPurchaseOrg/add', params)
}
export function editPurchaseOrg(params) {
    return post(SERVICE_URL + '/mdPurchaseOrg/edit', params)
}
export function deletePurchaseOrg(params, pathParam) {
    return get(SERVICE_URL + '/mdPurchaseOrg/remove', params, pathParam)
}

//采购类型
export function fetchPurchaseTypeList(params) {
    return post(SERVICE_URL + '/mdPurchaseType/mdPurchaseTypeList', params)
}

export function getPurchaseTypeList(params) {
    return post(SERVICE_URL + '/mdPurchaseType/list', params)
}

export function getPurchaseTypeAll() {
    return post(SERVICE_URL + '/mdPurchaseType/all')
}

export function getPurchaseTypeById(params, pathParam) {
    return get(SERVICE_URL + '/mdPurchaseType/getById', params, pathParam)
}
export function createPurchaseType(params) {
    return post(SERVICE_URL + '/mdPurchaseType/add', params)
}
export function editPurchaseType(params) {
    return post(SERVICE_URL + '/mdPurchaseType/edit', params)
}
export function deletePurchaseType(params, pathParam) {
    return get(SERVICE_URL + '/mdPurchaseType/remove', params, pathParam)
}
export function togglePurchaseTypeEnabled(params, pathParam) {
    return get(SERVICE_URL + '/mdPurchaseType/toggle', params, pathParam)
}


//存储位置
export function fetchStorePositionTypeList(params) {
    return post(SERVICE_URL + '/mdStorePosition/mdStorePositionList', params)
}
export function getStorePositionById(params, pathParam) {
    return get(SERVICE_URL + '/mdStorePosition/getById', params, pathParam)
}
export function createStorePosition(params) {
    return post(SERVICE_URL + '/mdStorePosition/add', params)
}
export function editStorePosition(params) {
    return post(SERVICE_URL + '/mdStorePosition/edit', params)
}
export function deleteStorePosition(params, pathParam) {
    return get(SERVICE_URL + '/mdStorePosition/remove', params, pathParam)
}
export function getStorePositionTypeList(params) {
    return post(SERVICE_URL + '/mdStorePosition/list', params)
}

//税码
export function fetchTaxCodeList(params) {
    return post(SERVICE_URL + '/mdTaxCode/mdTaxCodeList', params)
}
export function getTaxCodeById(params, pathParam) {
    return get(SERVICE_URL + '/mdTaxCode/getById', params, pathParam)
}
export function createTaxCode(params) {
    return post(SERVICE_URL + '/mdTaxCode/add', params)
}
export function editTaxCode(params) {
    return post(SERVICE_URL + '/mdTaxCode/edit', params)
}
export function deleteTaxCode(params, pathParam) {
    return get(SERVICE_URL + '/mdTaxCode/remove', params, pathParam)
}
export function getTaxCodeList(params) {
    return post(SERVICE_URL + '/mdTaxCode/list', params)
}

//单位
export function fetchUnitList(params) {
    return post(SERVICE_URL + '/mdUnit/mdUnitList', params)
}
export function getUnitById(params, pathParam) {
    return get(SERVICE_URL + '/mdUnit/getById', params, pathParam)
}
export function createUnit(params) {
    return post(SERVICE_URL + '/mdUnit/add', params)
}
export function editUnit(params) {
    return post(SERVICE_URL + '/mdUnit/edit', params)
}
export function deleteUnit(params, pathParam) {
    return get(SERVICE_URL + '/mdUnit/remove', params, pathParam)
}
export function getUnitList(params) {
    return post(SERVICE_URL + '/mdUnit/list', params)
}

// 采购路线
export function fetchPurchaseRouteList(params) {
    return post(SERVICE_URL + '/purchaseRoute/purchaseRouteList', params)
}
export function getPurchaseRouteList(params) {
    return post(SERVICE_URL + '/purchaseRoute/list', params)
}
export function getPurchaseRouteById(params, pathParam) {
    return get(SERVICE_URL + '/purchaseRoute/getById', params, pathParam)
}
export function createPurchaseRoute(params) {
    return post(SERVICE_URL + '/purchaseRoute/addPurchaseRoute', params)
}
export function editPurchaseRoute(params) {
    return post(SERVICE_URL + '/purchaseRoute/editPurchaseRoute', params)
}
export function deletePurchaseRoute(params, pathParam) {
    return get(SERVICE_URL + '/purchaseRoute/removePurchaseRoute', params, pathParam)
}

// 采购价格
export function fetchPurchaseRoutePriceList(params) {
    return post(SERVICE_URL + '/purchaseRoutePrice/purchaseRoutePriceList', params)
}
export function getPurchaseRoutePriceList(params) {
    return post(SERVICE_URL + '/purchaseRoutePrice/list', params)
}
export function getPurchaseRoutePriceById(params, pathParam) {
    return get(SERVICE_URL + '/purchaseRoutePrice/getById', params, pathParam)
}
export function createPurchaseRoutePrice(params) {
    return post(SERVICE_URL + '/purchaseRoutePrice/addPurchaseRoutePrice', params)
}
export function editPurchaseRoutePrice(params) {
    return post(SERVICE_URL + '/purchaseRoutePrice/editPurchaseRoutePrice', params)
}
export function deletePurchaseRoutePrice(params, pathParam) {
    return get(SERVICE_URL + '/purchaseRoutePrice/removePurchaseRoutePrice', params, pathParam)
}


// 配额主数据
export function fetchQuotaMaterialList(params) {
    return post(SERVICE_URL + '/quotaMaterial/quotaMaterialPage', params)
}
// export function getMdMaterialMasterList(params) {
//     return post(SERVICE_URL + '/materialMaster/mdMaterialMasterList', params)
// }
export function getQuotaMaterialById(params, pathParam) {
    return get(SERVICE_URL + '/quotaMaterial/getQuotaMaterialById', params, pathParam)
}
export function createQuotaMaterial(params) {
    return post(SERVICE_URL + '/quotaMaterial/insertQuotaMaterial', params)
}
export function editQuotaMaterial(params) {
    return post(SERVICE_URL + '/quotaMaterial/updateQuotaMaterial', params)
}
export function deleteQuotaMaterial(params, pathParam) {
    return get(SERVICE_URL + '/quotaMaterial/deleteQuotaMaterial', params, pathParam)
}
//批量导出
export function exportQuotaMaterial(params) {
    return post(SERVICE_URL + '/uploadFile/exportQuotaMaterial', params)
}
//导出 导入模板
export function exportTemplate() {
	return post(SERVICE_URL + '/quotaMaterial/exportTemplate')
}
//配额导入
export function importQuotaMaterial(params) {
    return upload(SERVICE_URL + '/uploadFile/importQuotaMaterial', params)
}
//批量删除
export function deleteQuotaMaterialList(params) {
    return post(SERVICE_URL + '/quotaMaterial/deleteQuotaMaterialList', params)
}
//批量推送
export function pushSapBack(params) {
    return post(SERVICE_URL + '/quotaMaterial/pushSapBack', params)
}

// 配额详细
export function fetchQuotaMaterialDetailList(params) {
    return post(SERVICE_URL + '/quotaMaterialDetail/quotaMaterialDetailPage', params)
}
// export function getMdMaterialMasterList(params) {
//     return post(SERVICE_URL + '/materialMaster/mdMaterialMasterList', params)
// }
export function getQuotaMaterialDetailById(params, pathParam) {
    return get(SERVICE_URL + '/quotaMaterialDetail/getQuotaMaterialDetailById', params, pathParam)
}
export function createQuotaMaterialDetail(params) {
    return post(SERVICE_URL + '/quotaMaterialDetail/insertQuotaMaterialDetail', params)
}
export function editQuotaMaterialDetail(params) {
    return post(SERVICE_URL + '/quotaMaterialDetail/updateQuotaMaterialDetail', params)
}
export function deleteQuotaMaterialDetail(params, pathParam) {
    return get(SERVICE_URL + '/quotaMaterialDetail/deleteQuotaMaterialDetail', params, pathParam)
}

// 通用器具类型
export function fetchApplianceTypeList(params) {
    return post(SERVICE_URL + '/mdApplianceType/mdApplianceTypeList', params)
}
export function getApplianceTypeList(params) {
    return post(SERVICE_URL + '/mdApplianceType/list', params)
}
export function getApplianceTypeById(params, pathParam) {
    return get(SERVICE_URL + '/mdApplianceType/getById', params, pathParam)
}
export function createApplianceType(params) {
    return post(SERVICE_URL + '/mdApplianceType/add', params)
}
export function deleteApplianceType(params, pathParam) {
    return get(SERVICE_URL + '/mdApplianceType/remove', params, pathParam)
}

// 快递公司配置
export function fetchExpressCompanyList(params) {
    return post(SERVICE_URL + '/mdExpressCompany/mdExpressCompanyList', params)
}
export function getExpressCompanyList(params) {
    return post(SERVICE_URL + '/mdExpressCompany/list', params)
}
export function getExpressCompanyById(params, pathParam) {
    return get(SERVICE_URL + '/mdExpressCompany/getById', params, pathParam)
}
export function createExpressCompany(params) {
    return post(SERVICE_URL + '/mdExpressCompany/add', params)
}
export function deleteExpressCompany(params, pathParam) {
    return get(SERVICE_URL + '/mdExpressCompany/remove', params, pathParam)
}

// 移动类型字典
export function fetchMoveTypeList(params) {
    return post(SERVICE_URL + '/mdMoveType/mdMoveTypeList', params)
}
export function getMoveTypeList(params) {
    return post(SERVICE_URL + '/mdMoveType/list', params)
}
export function getMoveTypeById(params, pathParam) {
    return get(SERVICE_URL + '/mdMoveType/getById', params, pathParam)
}
export function createMoveType(params) {
    return post(SERVICE_URL + '/mdMoveType/add', params)
}
export function deleteMoveType(params, pathParam) {
    return get(SERVICE_URL + '/mdMoveType/remove', params, pathParam)
}

export function queryVenderCodeRule(params) {
    return post(SERVICE_URL + '/mdVenderCode/query', params)
}
export function updateVenderCodeRule(params) {
    return post(SERVICE_URL + '/mdVenderCode/update', params)
}
export function queryNewCode(params) {
    return post(SERVICE_URL + '/mdVenderCode/queryNewCode', params)
}